<div s2aLayout="row" s2aLayoutAlign="start center" class="divider">
  <div class="separator disableSelection text-ellipsis">
    {{ separatorText | translate }}
  </div>
</div>
